import React__default from 'react';
import styled from 'styled-components';
import { tokens } from '../../../tokens.js';
import { Text } from '../../text/Text.js';

const cssvars = tokens.components.input.description;
const Description = styled.div`
  color: ${cssvars.color};
  font-size: ${cssvars["font-size"]};
  min-height: 0;
  padding-left: 0.75rem;

  /* Override any Stack component layout behaviour */
  &:not([data-hd-reservespace='true']):not([data-hd-empty='true']) {
    margin-top: 0;
  }

  &[data-hd-reservespace='true'] {
    min-height: 1em;
  }

  [data-hd-error='true'] &,
  &[data-hd-error='true'] {
    color: ${cssvars.error.color};
  }
`;
const InputDescription = ({ reserveMessageSpace =true , error , description  })=>{
    const text = error !== undefined && error !== "" ? error : description;
    return React__default.createElement(Description, {
        "data-hd-reservespace": reserveMessageSpace,
        "data-hd-empty": text !== undefined && text !== "",
        "data-hd-input-description": true
    }, React__default.createElement(Text, {
        size: "small"
    }, text));
};
InputDescription.dataId = "data-hd-input-description";
InputDescription.displayName = "InputDescription";

export { InputDescription };
